import { Company } from '@nextforce/api'
import { Icon, Text, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import { View } from 'react-native'
import { PressableOpacity } from 'shared/components/pressable_opacity'

interface CompanyInfoProps {
  company: Company | undefined
  memberCount: number
  onAddUser: () => void
  setSearchEnabled: React.Dispatch<React.SetStateAction<boolean>>
}
export function CompanyInfoView({
  company,
  memberCount,
  onAddUser: onAddUser,
  setSearchEnabled,
}: CompanyInfoProps) {
  const styles = useStyles()
  return (
    <View style={styles.infoContainer}>
      {company?.name ? (
        <Text style={styles.companyName}>{company.name}</Text>
      ) : null}
      <View style={styles.memberCountRow}>
        <View style={styles.memberCountContainer}>
          <Text style={styles.memberCountText}>{memberCount}</Text>
        </View>
        <Text>{t('members')}</Text>
      </View>
      <View style={styles.buttonRow}>
        <View style={styles.buttonContainer}>
          <PressableOpacity style={styles.button} onPress={onAddUser}>
            <Icon name="plus" type="feather" />
          </PressableOpacity>
          <Text style={styles.buttonLabel}>Add</Text>
        </View>
        <View style={styles.buttonContainer}>
          <PressableOpacity
            style={styles.button}
            onPress={() => setSearchEnabled(true)}
          >
            <Icon name="search" type="ionicons" />
          </PressableOpacity>
          <Text style={styles.buttonLabel}>Search</Text>
        </View>
      </View>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  companyName: {
    fontSize: 24,
    marginVertical: 10,
  },
  infoContainer: {
    alignItems: 'center',
    padding: 10,
    backgroundColor:
      theme.mode === 'dark' ? theme.colors.grey7 : theme.colors.grey6,
  },
  memberCountRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  memberCountContainer: {
    margin: 5,
    padding: 5,
    backgroundColor: theme.colors.peach,
    borderRadius: 50,
  },
  memberCountText: {
    fontSize: 20,
    paddingHorizontal: 5,
    color: 'black',
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  buttonContainer: {
    alignItems: 'center',
    marginHorizontal: 10,
    marginTop: 10,
  },
  button: {
    padding: 10,
    borderWidth: 0.5,
    width: 50,
    height: 50,
    borderColor: theme.colors.grey3,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 15,
    backgroundColor: theme.colors.white,
  },
  buttonLabel: {
    fontSize: 12,
    marginTop: 5,
  },
}))
